export class SearchObserver {
	private observer: MutationObserver;
	private targetElement: Element | null = null;
	private childClass: string;
	private callback: (() => void) | null = null;
	private debounceTimer: number | null = null;
	private debounceDelay: number = 200;

	public constructor(
		childClass: string
	) {
		this.childClass = childClass;

		this.observer = new MutationObserver((mutations) => {
			this.handleMutations(mutations);
		});
	}

	public observe(targetSelector: string, callback: () => void): void {
		this.callback = callback;
		this.targetElement = document.querySelector(targetSelector);

		if (!this.targetElement) {
			console.warn(`SearchResultsObserver: Container element with selector "${targetSelector}" not found`);
			return;
		}

		const config: MutationObserverInit = {
			childList: true,
			subtree: true,
			attributes: false
		};

		this.observer.observe(this.targetElement, config);
	}

	public disconnect(): void {
		if (this.debounceTimer) {
			clearTimeout(this.debounceTimer);
			this.debounceTimer = null;
		}
		this.observer.disconnect();
		this.targetElement = null;
		this.callback = null;
	}

	private handleMutations(mutations: MutationRecord[]): void {
		let hasNewCards = false;

		for (const mutation of mutations) {
			if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
				if (this.checkForSearchCards(mutation.addedNodes)) {
					hasNewCards = true;
				}
			}
		}

		if (hasNewCards) {
			if (this.debounceTimer) {
				clearTimeout(this.debounceTimer);
			}

			this.debounceTimer = window.setTimeout(() => {
				this.notifySearchResultsUpdated();

				this.disconnect();
			}, this.debounceDelay);
		}
	}

	private checkForSearchCards(nodes: NodeList): boolean {
		let foundCards = false;

		for (const node of Array.from(nodes)) {
			if (node.nodeType === Node.ELEMENT_NODE) {
				const element = node as Element;

				if (element.classList.contains(this.childClass)) {
					foundCards = true;
				}
			}
		}

		return foundCards;
	}

	public notifySearchResultsUpdated(): void {
		if (this.callback) {
			this.callback();
		}
	}
}